// action-button.component.ts
import { Component, Input, Output, EventEmitter } from '@angular/core';
import {CommonModule} from '@angular/common';
import {LoadingSpinnerComponent} from '../ui/loading-spinner-component';
import {BaseButtonComponent} from './base-button.component';

@Component({
  standalone: true,
  imports: [CommonModule, LoadingSpinnerComponent, BaseButtonComponent],
  selector: 'app-action-button',
  template: `
    <app-base-button
      [baseClass]="'w-full bg-theme-primary text-theme-contrast py-3 px-6 rounded-2xl flex items-center justify-between h-14'"
      [disabled]="disabled"
      (onClick)="onClick.emit($event)"
    >
      <div class="flex justify-center w-full" [class]="getOpactity()">
        <div class="flex flex-row items-center">
          <i *ngIf="icon" class="fas text-xl" [class]="icon" [class.mr-4]="text"></i>
          <div *ngIf="itemCount > 0" class="relative">
            <i class="fas fa-shopping-basket text-xl mr-4"></i>
            <div *ngIf="itemCount > 0"
                 class="absolute top-0 right-1 bg-theme-notification2 text-theme-notification2-text text-xs font-bold rounded-full h-5 w-5 flex items-center justify-center">
              {{ itemCount }}
            </div>
          </div>
          <span *ngIf="text" class="text-center text-lg font-bold tabular-nums">{{ text }}</span>
          <i *ngIf="chevron" class="fas fa-chevron-circle-right text-xl ml-3"></i>
          <div class="absolute left-12" *ngIf="spinner">
            <app-loading-spinner size="sm-md" color="text-theme-contrast"></app-loading-spinner>
          </div>
        </div>
      </div>
    </app-base-button>
  `
})
export class ActionButtonComponent {
  @Input() text?: string;
  @Input() icon?: string;
  @Input() disabled: boolean = false;
  @Output() onClick = new EventEmitter<MouseEvent>();
  @Input() itemCount: number = 0;
  @Input() spinner: boolean = false;
  @Input() chevron: boolean = true;

  getOpactity() {
    return this.disabled ? 'opacity-50' : '';
  }
}
